import {useState} from 'react'
import {  useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

import BasicSelector from '../ui/BasicSelector.jsx'
import { useSelector,useDispatch } from 'react-redux'
import { setLang } from '../../store/langSlice.js'

// ICONS 
import {VscAccount} from 'react-icons/vsc'
import {MdNotificationsNone,MdSupport} from 'react-icons/md'
import { MdLanguage, MdLockOutline, MdLogout, MdPersonOutline } from 'react-icons/md'
// import DarkModeToggle from '../ui/DarkModeToggle.jsx'; // dark mode toggle hidden temporarily

const normalizeLang = (value) => String(value || '').toLowerCase().startsWith('ar') ? 'ar' : 'en';

const getLanguageLabel = (language) => {
    const code = normalizeLang(language?.langCode || language?.value || language?.code || language);
    const rawName = String(language?.langName || language?.name || '').trim();
    if (code === 'ar') return 'عربي';
    if (code === 'en') return 'English';
    if (rawName && rawName.toLowerCase() !== 'language') return rawName;
    return code || rawName;
};

const UserBar = ({tenantUsername,tenant}) => {
    const [t,i18n] = useTranslation('global')
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const _token = localStorage.getItem('token');
    const user = useSelector((state) => state.auth).user;
    const currentCompany = useSelector((state) => state.currentCompany);
    const currentBranch = useSelector((state) => state.currentBranch);
    
    const listLangHandler = tenant?.languages?.map(language => ({
        label: getLanguageLabel(language),
        value: normalizeLang(language?.langCode || language?.value || language?.code)
    })).filter((language) => language.value) || []
    const langSelected = useSelector((state)=>state.lang)
    const currentLangValue = normalizeLang(langSelected?.value || i18n.language || 'ar');

    const logoutHandler = () => {
        navigate(`/${tenantUsername}/logout`)
    }
    const onSelectedLangHandler = (lang) => {
        const nextLang = normalizeLang(lang.value);
        try {
            localStorage.setItem('preferredLang', nextLang);
            localStorage.setItem('appLang', nextLang);
            localStorage.setItem('i18nextLng', nextLang);
        } catch {
        }
        const dir = nextLang === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.lang = nextLang;
        document.documentElement.dir = dir;
        document.body.dir = dir;
        document.body.classList.remove('rtl', 'ltr');
        document.body.classList.add(dir);
        i18n.changeLanguage(nextLang)
        dispatch(setLang({label:lang.label,value:nextLang}))
        saveCentralSelection(
            currentCompany?.value || user?.company_id,
            currentBranch?.value || user?.branch_id,
            nextLang
        );
    }
    const toggleLangHandler = () => {
        const nextLangValue = currentLangValue === 'ar' ? 'en' : 'ar';
        const nextLang = listLangHandler.find((lang) => lang.value === nextLangValue) || {
            label: nextLangValue === 'ar' ? 'عربي' : 'English',
            value: nextLangValue
        };
        onSelectedLangHandler(nextLang);
    }


    const onSelectedUserList = (item) => {
        switch (item.value) {
            case 'MyAccount':
                navigate(`/${tenantUsername}/settings`, { state: { tab: 'profile' } })
                break;
            case 'ChangePassword':
                navigate(`/${tenantUsername}/settings`, { state: { tab: 'password' } })
                break;
            case 'Logout':
                logoutHandler()
                break;
            default:
                break;
        }
    }

    // User List
    const [openListUser,setOpenListUser] = useState(false);
    const userList = [
        {label:'حسابي',value:'MyAccount', icon:<MdPersonOutline size={16}/>},
        {label:'تغيير كلمة المرور',value:'ChangePassword', icon:<MdLockOutline size={16}/>},
        {label:'تسجيل الخروج',value:'Logout', icon:<MdLogout size={16}/>},
    ]
    const saveCentralSelection = async (selectedCompanyId, selectedBranchId, selectedLang) => {
        if (!user?.tenant_id) return;
        const token = localStorage.getItem('token');
        if (!token) return;
        try {
            await axios.put(
                `${process.env.REACT_APP_Auth_API_BASE_URL}/settings/central`,
                {
                    tenantId: user.tenant_id,
                    scope: 'header-selection',
                    data: {
                        selectedCompanyId,
                        selectedBranchId,
                        selectedLang
                    }
                },
                {
                    headers: { Authorization: `Bearer ${token}` },
                    validateStatus: () => true
                }
            );
        } catch (error) {
        }
    };
    return (
        <div className='flex items-center justify-between md:justify-end gap-0.5 text-xs text-white w-full md:w-auto'>
     {/* <DarkModeToggle className='shrink-0' /> */}

            <BasicSelector 
                border={false}
                listItem={userList}
                label={user?.name || ''}
                defaultValue={user?.name || ''}
                openList={openListUser}
                setOpenList={setOpenListUser}
                withChangeLabel={false}
                onSelected={onSelectedUserList}
                className='shrink-0'
                >
                    <VscAccount size={14}/> 
                </BasicSelector>

            <div className='text-white/70 px-0.5'>|</div>
            
            <BasicSelector withArrow={false} border={false} className='shrink-0'> <MdNotificationsNone size={16} /></BasicSelector>
            
            <div className='text-white/70 px-0.5'>|</div>
            
            <Link className='inline-flex h-6 w-6 shrink-0 items-center justify-center transition-all active-hover' to={`${process.env.REACT_APP_WEB_SUPPORT_BASE_URL}/${tenantUsername}/token/${encodeURIComponent(_token || '')}`}> <MdSupport size={16} /> </Link>
            
            <div className='text-white/70 px-0.5'>|</div>

            <button
                type='button'
                onClick={toggleLangHandler}
                className='cursor-pointer text-xs flex shrink-0 items-center justify-center whitespace-nowrap transition-all active-hover'
                aria-label='Toggle language'
                title={currentLangValue === 'ar' ? 'English' : 'عربي'}
            >
                <span className='inline-flex h-6 w-6 items-center justify-center text-[18px] leading-none'>
                    <MdLanguage size={19} />
                </span>
            </button>

        </div>
    )
} 

 
export default UserBar 

